const defaultContent = {
  signupWithGoogleHeading: 'Sign up with Google',
  signupWithFacebookHeading: 'Sign up with Facebook',
  signupWithApple: 'Signup with Apple',
  signupCreateAccount: 'or do it the old school way',
  signupButton: 'Sign up with Email',
  firstNameHeading: 'First name',
  lastnameHeading: 'Last name',
  preferredNameHeading: 'Preferred name',
  emailHeading: 'Email',
  passwordHeading: 'Password',
  passwordMessage: 'Minimum 8 characters with a mixture of letters (one capital), numbers and symbols (1 special).',
  dobHeading: 'Date of birth',
  virginVoyagesNews: 'Virgin Voyages news',
  newsMessage:
    'Fun, ship puns and exclusive travel news are all yours with a simple check of the box. (Our privacy policy means your details stay safe.)',
  emailSubscription: 'Yes please! I want to receive lovely email updates from Virgin Voyages',
  signupWithEmail: 'Sign up with email',
};

export default defaultContent;
